<template>
    <v-row>
        <v-col
            md="12"
        >
            <v-card elevation="5" class="pa-md-4">
                <v-row>
                    <v-col
                        md="9"
                    >
                        <h2 class="display-1 font-weight-normal">{{shops[0].name}}</h2>
                    </v-col>
                    <v-col
                        md="3"
                        class="ml-md-n6"
                    >
                        <v-row>
                            <v-col
                                md="3"
                            >
                                <v-btn
                                    fab
                                    x-small
                                    color="primary"
                                    outlined
                                >
                                    <v-icon>
                                        mdi-information-slab-box
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                md="3"
                            >
                                <v-btn
                                    fab
                                    x-small
                                    color="orange"
                                    outlined
                                >
                                    <v-icon>
                                        mdi-pen
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                md="3"
                            >
                                <v-btn
                                    fab
                                    x-small
                                    color="red"
                                    outlined
                                >
                                    <v-icon>
                                        mdi-delete-empty-outline
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                md="3"
                            >
                                <v-btn
                                    fab
                                    x-small
                                    color="red"
                                    outlined
                                    class="backFlipBtn" 
                                    @click="updateValue(true)"
                                >
                                    <v-icon>
                                        mdi-axis-z-rotate-clockwise
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                    v-for="index in 4"
                    :key="index"
                >
                    <v-col
                        md="10"
                        class="pt-md-8 ml-md-6"
                    >
                        <v-row class="d-flex justify-center">
                            <v-col
                                md="5"
                                align-self="center"
                            >
                                <h2 class="font-weight-light">{{shops[0].id}}</h2>
                            </v-col>
                            <v-col
                                md="6"
                                align-self="center"
                            >
                                <h3 class="font-weight-light grey--text">Calle Hola nº19</h3>
                            </v-col>
                            <v-col
                                md="1"
                                align-self="center"
                            >
                                <v-icon
                                    size="48"
                                >
                                    {{icons[index-1]}}
                                </v-icon>
                            </v-col>
                        </v-row> 
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>


<script>

    export default {
        name : 'ShopAdministrationBase',
        props: [
            'value'
        ],
        data : () => ({
            shops : [
                {
                    id: 'Dirección',
                    name : 'Serrallo',
                    comerciales: 2,
                },
            ],
            icons: ['mdi-store-outline', 'mdi-account-key-outline', 'mdi-email-search', 'mdi-home-analytics']
        }),
        methods: {
            updateValue: function (value) {
                this.$emit('input', value);
            }
        }
    }
</script>


<style>

</style>